import React from 'react';
import { Token } from '@uniswap/sdk-core';
import {
  Box, Button, ButtonProps, styled, Typography,
} from '@mui/material';
import { TokenSelectButton } from 'common-client';

const NextButton = styled(Button, { name: 'NextButton' })<ButtonProps>(() => ({
  borderRadius: '24px',
  textTransform: 'capitalize',
}));

export interface SelectPairBoxProps {
  /**
   * Prompt to display
   */
  prompt?: string;
  /**
   * Sell asset
   */
  sellAsset?: Token;
  /**
   * Callback for triggering sell asset selection
   */
  onSellAssetClick?: () => void;
  /**
   * Bid asset
   */
  bidAsset?: Token;
  /**
   * Callback for triggering bid asset selection
   */
  onBidAssetClick?: () => void;
  /**
   * Callback on clicking next button
   */
  onNextClick?: () => void;
}

export function SelectPairBox({
  prompt,
  sellAsset,
  onSellAssetClick,
  bidAsset,
  onBidAssetClick,
  onNextClick,
}: SelectPairBoxProps) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      flexWrap="nowrap"
    >
      <Typography variant="h3" fontWeight={700} fontSize="24px" lineHeight="32px" color="textPrimary" my="8px">
        Select Pair
      </Typography>
      { prompt && (
      <Typography variant="body1" fontWeight={400} fontSize="16px" lineHeight="24px" color="textSecondary" mb="16px">
        {prompt}
      </Typography>
      )}
      <Typography variant="body1" fontWeight={700} fontSize="16px" lineHeight="24px" color="textPrimary" mb="8px">
        Sell Asset
      </Typography>
      <Box mb="24px">
        <TokenSelectButton token={sellAsset} onClick={onSellAssetClick} />
      </Box>
      <Typography variant="body1" fontWeight={700} fontSize="16px" lineHeight="24px" color="textPrimary" mb="8px">
        Buy Asset
      </Typography>
      <Box mb="24px">
        <TokenSelectButton token={bidAsset} onClick={onBidAssetClick} />
      </Box>
      <NextButton variant="contained" onClick={onNextClick} disabled={!sellAsset || !bidAsset}>
        <Typography variant="body1" fontWeight={600} fontSize="14px" lineHeight="24px">
          Next
        </Typography>
      </NextButton>
    </Box>
  );
}
